<template>
  <div class="infinite-scroll">
    <slot />
    <div ref="trigger" />
  </div>
</template>

<script>
export default {
  name: 'InfiniteScroll',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      observer: null,
    }
  },

  watch: {
    disabled (value) {
      value
        ? this.destroyObserver()
        : this.createObserver()
    },
  },

  mounted () {
    this.createObserver()
  },

  destroyed () {
    this.destroyObserver()
  },

  methods: {
    createObserver () {
      if (!this.disabled) {
        this.observer = new IntersectionObserver(this.callbackObserver)
        this.observer.observe(this.$refs.trigger)
      }
    },

    destroyObserver () {
      if (this.observer) this.observer.disconnect()
    },

    callbackObserver ([entry]) {
      if (entry && entry.isIntersecting) {
        this.$emit('intersect')
      }
    },
  },
}
</script>
